import React, { useCallback } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { notifications } from '../notifications';
import { messages } from './messages';
import style from './style.module.less';

const Save = () => <FormattedMessage {...messages.save} />;
const Saving = () => <FormattedMessage {...messages.saving} />;

/**
 *
 * @param {object} props
 * @param {() => Promise<void>} props.onSave
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const SaveBar = ({ onSave, disabled = false, className = '' }) => {
  const [saving, setSaving] = useAsyncSafeState(false);
  const onClick = useCallback(async () => {
    setSaving(true);

    try {
      await onSave();
      notifications.success();
    } catch (e) {
      notifications.error(e);
    }
    setSaving(false);
  }, [onSave, setSaving]);

  return (
    <div className={classnames(style.pinned, className)}>
      <Button className={classnames({ [style.saving]: saving })} disabled={saving || disabled} onClick={onClick} theme='primary'>
        {saving ? <Saving /> : <Save />}
      </Button>
    </div>
  );
};

export default SaveBar;
